export default {
  breakfast: 'Breakfast',
  am_snack: 'AM Snack',
  pm_snack: 'PM Snack',
  lunch: 'Lunch',
  late_snack: 'Late Snack',
  dinner: 'Dinner'
};
